import { useMemo } from 'react';
import { AVPlaybackSourceObject } from 'expo-av';

import { useFetchMedia } from '@pletly/ui';

export const useMediaSource = ({ uri, headers }: AVPlaybackSourceObject) => {
	const authorizationHeader = headers?.Authorization;

	const memoizedSource = useMemo(() => {
		return {
			uri,
			headers: authorizationHeader ? { Authorization: authorizationHeader } : undefined,
		};
	}, [authorizationHeader, uri]);
	const downloadedUri = useFetchMedia(memoizedSource); // @TODO Fix sending web auth headers in order to not download entire file first

	const fetchedMedia = { uri: downloadedUri };

	return fetchedMedia;
};
